import React, { useEffect, useRef, useState } from "react";
import { Map, TileLayer, Marker, FeatureGroup } from "react-leaflet";
import L from "leaflet";
import markerIcon2x from "leaflet/dist/images/marker-icon-2x.png";
import markerIcon from "leaflet/dist/images/marker-icon.png";
import markerShadow from "leaflet/dist/images/marker-shadow.png";
import { removeEmptyObjFromArrayObj } from "../../../../utils/functions/functions";
import { getMapboxTileUrl } from "../../../../settings/mapboxTiles";
import "leaflet/dist/leaflet.css";

function doCleanData(data) {
  let cleanData = data.filter(function (item) {
    return item != null;
  });
  cleanData = removeEmptyObjFromArrayObj(cleanData);
  return cleanData;
}

export default ({ mapStyle, data }) => {
  useEffect(() => {
    delete L.Icon.Default.prototype._getIconUrl;

    L.Icon.Default.mergeOptions({
      iconRetinaUrl: markerIcon2x,
      iconUrl: markerIcon,
      shadowUrl: markerShadow,
    });
  }, []);

  const [refreshComponent, setRefreshComponent] = useState(true);

  useEffect(() => {
    // refresh component to cause map to center properly
    setRefreshComponent(false);
  }, [setRefreshComponent]);

  const mapRef = useRef(null);
  const groupRef = useRef(null);

  const cleanData = doCleanData(data);

  useEffect(() => {
    if (
      cleanData.length === 0 ||
      cleanData.length === 1 ||
      !mapRef.current ||
      !groupRef.current
    ) {
      return;
    }

    const map = mapRef.current.leafletElement;
    const group = groupRef.current.leafletElement;

    map.fitBounds(group.getBounds());
  }, [cleanData]);

  return cleanData.length !== 0 ? (
    <>
      <h2 style={{ margin: "30px 0 10px 0" }}>Map Preview</h2>
      <Map
        center={[cleanData[0].latitude, cleanData[0].longitude]}
        zoom={13}
        style={mapStyle}
        ref={mapRef}
      >
        <TileLayer
          attribution='&amp;copy <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
          url={getMapboxTileUrl()}
        />
        <FeatureGroup ref={groupRef}>
          {cleanData.map((address, index) => {
            return (
              <Marker
                position={[parseFloat(address.latitude), parseFloat(address.longitude)]}
                key={index}
              ></Marker>
            );
          })}
        </FeatureGroup>
      </Map>
    </>
  ) : null;
};
